export default __webpack_public_path__ + "static/media/compassbtnicon.ada27826.svg";